import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getData(params) { //获取控制台基本信息
    const url =  baseURL + '/tbUser/infoCount';
    return axios.post(url, qs.stringify(params));
  },
  pointByHour(params) { //折线图
    const url =  baseURL + '/tbUser/pointByHour';
    return axios.post(url, qs.stringify(params));
  },
  dayVisit(params) { //日活统计
    const url =  baseURL + '/tbUser/dayVisit';
    return axios.post(url, qs.stringify(params));
  },
  yaerVisit(params) {
    const url =  baseURL + '/tbUser/activeUserByYear';
    return axios.post(url, qs.stringify(params));
  },
  registerCount(params) { //新注册用户统计
    const url =  baseURL + '/tbUser/registerCount';
    return axios.post(url, qs.stringify(params));
  },
  adminModulePointPie(params) { //模块使用情况分析图
    const url =  baseURL + '/tbAuthorizedproduct/adminModulePointPie';
    return axios.post(url, qs.stringify(params));
  },
  getPeiAddress(params) { //用户归属地统计
    const url =  baseURL + '/statistical/getPeiAddressCa';
    return axios.post(url, qs.stringify(params));
  },
}


// WEBPACK FOOTER //
// ./src/api/Management.js